import React, { ComponentProps, ReactNode } from 'react';

import PropTypes from 'prop-types';

import { useTheme } from '@adsk/alloy-react-styles';

import ActivityCard from '../ActivityCard';

type PhotoActivityCardProps = ComponentProps<typeof ActivityCard> & {
  label: ReactNode;
};

/**
 * PhotoActivityCard component. Describes a single photo add activity.
 */
const PhotoActivityCard = React.forwardRef<
  HTMLDivElement,
  PhotoActivityCardProps
>(({ label, children, ...props }, ref) => {
  const photoLabelTokens =
    useTheme().tokens?.component?.activityLog?.photoLabel;
  const { marginTop: photoLabelMarginTop, ...photoLabelTextTokens } =
    photoLabelTokens ?? {};

  return (
    <ActivityCard ref={ref} {...props}>
      {children}
      {label && (
        <span css={[photoLabelTextTokens, { marginTop: photoLabelMarginTop }]}>
          {label}
        </span>
      )}
    </ActivityCard>
  );
});

PhotoActivityCard.displayName = 'PhotoActivityCard';

PhotoActivityCard.propTypes = {
  ...ActivityCard.propTypes,
  /** The image name */
  label: PropTypes.any.isRequired,
  /** The image content */
  children: PropTypes.any,
};

export default PhotoActivityCard;
